import { ArrowDown, BadgeCheck } from 'lucide-react';

interface BrandAnswerBoxProps {
  quickAnswer: string;
  path: string;
}

export function BrandAnswerBox({ quickAnswer }: BrandAnswerBoxProps) {
  const handleScrollToContent = () => {
    const contentEl = document.getElementById('article-main-content');
    if (contentEl) {
      contentEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="mt-6 rounded-xl border border-gray-200 bg-gray-50 p-5" aria-labelledby="power-ng-answer">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-white border border-gray-200 text-[#008751] flex items-center justify-center flex-shrink-0">
          <BadgeCheck className="w-5 h-5" />
        </div>
        <div>
          <h2 id="power-ng-answer" className="text-base font-bold text-gray-900 mb-2">
            Quick Answer
          </h2>
          <p className="text-gray-700 leading-relaxed">
            {quickAnswer}
          </p>
          <button
            onClick={handleScrollToContent}
            className="inline-flex items-center gap-2 text-[#008751] font-semibold mt-3 hover:text-[#006d41] transition-colors"
          >
            Read the full guide
            <ArrowDown className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}
